<template>
  <div style="width: 1260px;text-align: center;margin: auto">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <div class="app-body-1160px">
      <img alt="pic" src="https://img.blendermagic.cn/new/about/about.jpg" style="width:1160px;height: 250px;"/>
      <!-- 开源价值 -->
      <AboutSupport></AboutSupport>
      <!-- 友情链接 -->
      <FriendLink></FriendLink>
      <!-- 联系我们 -->
      <ContactUs></ContactUs>
    </div>
  </div>
</template>

<script>

import AboutSupport from "@/views/about/components/AboutSupport";
import FriendLink from "@/views/about/components/FriendLink";
import ContactUs from "@/views/about/components/ContactUs";
import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "About",
  components: {
    HeaderMain,
    ContactUs,
    FriendLink,
    AboutSupport
  },
  mounted() {
    document.title = "斑斓魔法CG-关于"
  }
}
</script>

